import { queryOptions } from "@tanstack/react-query";
import { createServerFn } from "@tanstack/react-start";

import { requireRole } from "@/auth/shared";
import { getBaseUrl } from "@/lib/url";
import {
  AUTH_URL,
  getSettingValue,
  SETTINGS_KEYS,
} from "@/services/constant-contact";

export const getConstantContactStatusFn = createServerFn({ method: "GET" })
  .middleware([requireRole(["admin", "superadmin"])])
  .handler(async () => {
    const [accessToken, refreshToken, expiresAtStr] = await Promise.all([
      getSettingValue(SETTINGS_KEYS.accessToken),
      getSettingValue(SETTINGS_KEYS.refreshToken),
      getSettingValue(SETTINGS_KEYS.expiresAt),
    ]);

    const expiresAt = expiresAtStr ? new Date(Number(expiresAtStr)) : null;
    const sixtyDaysAgo = new Date(Date.now() - 60 * 24 * 60 * 60 * 1000);
    const connected =
      accessToken != null &&
      refreshToken != null &&
      expiresAt != null &&
      expiresAt > sixtyDaysAgo;

    return { connected, expiresAt: expiresAt?.toISOString() ?? null };
  });

export const getConstantContactStatusQueryOptions = () =>
  queryOptions({
    queryKey: ["constant-contact-status"],
    queryFn: () => getConstantContactStatusFn(),
  });

export const getConstantContactAuthUrlFn = createServerFn({ method: "GET" })
  .middleware([requireRole(["admin", "superadmin"])])
  .handler(() => {
    const clientId = process.env.CONSTANT_CONTACT_CLIENT_ID;

    if (!clientId || clientId === "no-send") {
      return { url: null };
    }

    const params = new URLSearchParams({
      client_id: clientId,
      redirect_uri: `${getBaseUrl()}/api/oauth2/callback`,
      response_type: "code",
      scope: "contact_data offline_access",
      state: "constant-contact-auth",
    });

    return { url: `${AUTH_URL}?${params.toString()}` };
  });

export const getConstantContactAuthUrlQueryOptions = () =>
  queryOptions({
    queryKey: ["constant-contact-auth-url"],
    queryFn: () => getConstantContactAuthUrlFn(),
  });
